import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "Transed",
    isNumber: true,
    isSum: true,
  },
];

export const ReferralIsComplete = {
  label: "轉介是否完成",
  key: "ReferralIsComplete",
  path: "BoneMuscleCare/ReferralIsComplete",
  api: "TCS_V_CaseTransferInfo02V",
  render: (options) => (
    <Diagram.BoneMuscleCare.ReferralIsComplete {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "",
    },
  ],
  filterColumns: [{ key: "Q3967", type: "date" }],
  levelColumns,
  columns: [],
};
